export default function (Component) {
Component.options.__title = "Inline Help"
}